import { render, staticRenderFns } from "./guid.vue?vue&type=template&id=48d89350"
import script from "./guid.vue?vue&type=script&lang=js"
export * from "./guid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports